<template>
    <div class="relative col-span-1 h-full ">
        <VaSidebar v-model="store.state.ui.showSidebar" color="color1" gradient>
            <router-link v-for="(item, index) in routes" :key="index" :to="item.path">
                <va-sidebar-item class="cursor-pointer">
                    <va-sidebar-item-content>
                        <va-sidebar-item-title>
                            {{ item.name }}
                        </va-sidebar-item-title>
                    </va-sidebar-item-content>
                </va-sidebar-item>
            </router-link>
        </VaSidebar>
    </div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
const store = useStore();
const routes = [
    {
        name: 'Home',
        path: '/',
    },
    {
        name: 'Simple Scale',
        path: '/simple-scale',
    },
    {
        name: 'Continuous Intervals',
        path: '/continuous-intervals',
    },
    {
        name: 'Discrete Intervals',
        path: '/discrete-intervals',
    },
    {
        name: 'Arpeggio',
        path: '/arpeggio',
    },
    {
        name: 'Rhythm',
        path: '/rhythm',
    },
    {
        name: 'Rhythm Detector',
        path: '/rhythm/detector',
    },
    {
        name: 'About',
        path: '/about',
    },
    ...process.env.VUE_APP_MODE != 'development' ? [] : [
        {
            name: 'test',
            path: '/test',
        },
        {
            name: 'earTraining',
            path: 'ear-training'
        }
    ],
]

</script>